import React, { useId } from 'react';
import { oneOf } from 'prop-types';

import { themeObj } from '../../GlobalStyle';

const Checkmark = ({ variant = 'blue' }) => {
    const gradientId = useId();
    const variants = {
        blue: {
            gradient: `linear-gradient(180deg, ${themeObj.colorSystem.gradients[7][0]}, ${themeObj.colorSystem.gradients[7][1]})`,
            stroke: themeObj.colorSystem.UIText['3']
        },
        green: {
            fill: themeObj.colorSystem.validation['1'],
            stroke: themeObj.colorSystem.UIText['3']
        }
    };

    const config = variants[variant] || variants.blue;

    return (
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            {config.gradient ? (
                <>
                    <defs>
                        <linearGradient
                            id={gradientId}
                            x1="0%"
                            y1="0%"
                            x2="0%"
                            y2="100%">
                            <stop
                                offset="0%"
                                stopColor={
                                    themeObj.colorSystem.gradients[7][0]
                                }
                            />
                            <stop
                                offset="100%"
                                stopColor={
                                    themeObj.colorSystem.gradients[7][1]
                                }
                            />
                        </linearGradient>
                    </defs>
                    <circle
                        cx="12"
                        cy="12"
                        r="12"
                        fill={`url(#${gradientId})`}
                    />
                </>
            ) : (
                <circle cx="12" cy="12" r="12" fill={config.fill} />
            )}
            <path
                d="M7.8001 13.2L9.73995 14.6549C9.99717 14.8478 10.3607 14.8036 10.5643 14.5548L15.6001 8.39996"
                stroke={config.stroke}
                strokeWidth="2"
                strokeLinecap="round"
            />
        </svg>
    );
};

Checkmark.propTypes = {
    variant: oneOf(['blue', 'green'])
};

export default Checkmark;
